$(function() {
    "use strict";

    if (window.File && window.FileReader && window.FileList && window.Blob) {

        $('.custom-file-input-w-background__input').on('change', function() {
            var reader = new FileReader();
            var $input = $(this);
            var key    = $input.data('key');
            var $image = $('.custom-file-input-w-background__image[data-key=' + key +']');

            if ($image.length > 0) {

                var file = $input.prop('files')[0];
                if (file.type.match(/image/)) {
                    reader.readAsDataURL(file);
                }

                reader.onloadend = function () {
                    $image.css('background-image', 'url(' + reader.result + ')');
                };
            }
        });
    }
});